import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { NavBar } from './NavBar'
import User from './User'
import { isClientUser } from '../../services/keycloak.service'
import { useHistory, useParams } from 'react-router-dom'
import { Pages } from '../../router/router'
import { useCurrentPage } from '../../hooks/useCurrentPage'
import { OrdersByStateCount } from '../../redux/reducers/orders'
import { useSelector } from '../../redux/hooks/useSelector'
import ClientCard from './ClientCard'
import { ClientInformationDialog } from '../dialogs/ClientInformationDialog'
import { Territory } from '../../redux/reducers/territories'
import { useUserApi } from '../../hooks/useUserApi'
import { AlertMessageConfirmation } from '../dialogs/AlertMessageConfirmation'
import { newThemeObject } from '../../newTheme'
import { isApexUser } from '../../utils/apex'

interface Props {
  pageName: string
}

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: theme.spacing(2),
    display: 'flex',
  },
  leftBar: {
    height: '100%',
    width: '300px',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1,
    margin: '10',
  },
  right: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  topBar: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: '300px',
  },
  child: {
    marginLeft: '300px',
    marginTop: 30,
    paddingRight: theme.spacing(3),
  },
  pageName: {
    fontWeight: 500,
    fontSize: '1.2rem',
    margin: 0,

    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: 'white',
    padding: theme.spacing(3),
    borderRadius: newThemeObject.roundness.basic,
    marginBottom: theme.spacing(2),
    marginRight: '20px',
    height: '85px',
  },
  titleRibon: {
    fontWeight: 500,
    fontSize: '1rem',
    margin: 0,
    textAlign: 'center'
  },
  rightTop: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  logo: {
    height: '40px',
    cursor: 'pointer',
    opacity: '30%',
    margin: '12px'
  },
  selectedLogo: {
    height: '40px',
    margin: '12px'
  },
  paperClass: {
    backgroundColor: '#FFF',
    borderRadius: '20px',
    paddingTop: '12px',
    height: '85px'
  }
}))

interface NewLayoutProps {
  setTerritoryChange?: (param: Territory) => any
  pageName: string
}


export const NewLayout: React.FC<NewLayoutProps> = ({ children, pageName, setTerritoryChange}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const curr = useCurrentPage()
  const [ordersByStateCount, setOrdersByStateCount] = useState([] as OrdersByStateCount[])
  const { clientId } = useParams<{ clientId: string }>()
  const orderSse = useSelector(state => state.orders.orderSse)
  const territories = useSelector(state => state.territories.territories)
  const user = useSelector(state => state.auth.user)
  const { updateUserTerritorySync, getUser } = useUserApi()
  const history = useHistory()
  const [activeTerritory, setActiveTerritory] = useState<Territory>();
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [openConfirmationSave, setOpenConfirmationSave] = useState<boolean>(false);
  const clientNameFromEmail = useSelector(state => state.clients.clientName);

  
  useEffect(() => {
    if (curr === Pages.Home && orderSse && orderSse.userStates && orderSse.userStates.length > 0) {
      setOrdersByStateCount(orderSse.userStates[0].states)
    }
  })

  useEffect(()=>{
    if ( activeTerritory && user && activeTerritory.businessTerritoryId === user.businessTerritoryId ) {
      setTerritoryChange?.(activeTerritory)
      history.push(Pages.Home)
    }
  }, [user])

  const hadleTerritoryChange = (item: Territory) => {
    setActiveTerritory(item);
    updateUserTerritorySync(item.businessTerritoryId, user.kcId)
  }

  const handleConfirmation2 = () => {
    setOpenConfirmation(false)
    setOpenConfirmationSave(true)
  }
  const handleCloseConfirmation2 = () => {
    setOpenConfirmation(false)
  }

  const ribon = process.env.REACT_APP_ENV_RIBBON
  return (
    <div className={classes.wrapper}>
      <div className={classes.leftBar}>
        <NavBar />
      </div>
      <div className={classes.right}>
        <div className={classes.topBar}>
          <span style={{display: 'flex', flexDirection: 'row'}}>
            <p className={classes.pageName}>{t(pageName)}</p>
            {!isClientUser() && clientId && <ClientCard />}
          </span>
          <span style={{marginLeft: 'auto', paddingRight: '20px'}}>
            { territories &&
            <div className={classes.paperClass} >
            { territories && territories.map((territory: Territory) => (
              <img src={'data:image/jpeg;base64,'+territory.logo} alt={territory.description} className={user && user.businessTerritoryId===territory.businessTerritoryId?classes.selectedLogo:classes.logo} onClick={()=>{hadleTerritoryChange(territory)}}/>
            ))}
            </div>}
            {ribon && (
              <p 
                className={classes.titleRibon} 
                // style={!isClientUser()?{marginLeft: '-200px', color: '#ff0000'}:{color: '#ff0000'}}
                style={{color: '#ff0000'}}
              >
                {ribon}
              </p>
            )}
          </span>
          <User />
        </div>
        <div className={classes.child}>{children}</div>
      </div>
      <ClientInformationDialog 
        setOpenConfirmation={setOpenConfirmation}
        openConfirmationSave={openConfirmationSave}
        setOpenConfirmationSave={setOpenConfirmationSave}
      />
      <AlertMessageConfirmation
        alertOpen={openConfirmation}
        onOk={handleConfirmation2}
        onCancle={handleCloseConfirmation2}
        alertText={t('DUPLICITY_EMAIL_VALIDATION_TEXT', {name: clientNameFromEmail.name})}
      />

    </div>
  )
}
